import React from "react";
import { CONFIG } from "../../config/keys";
import axios from "axios";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import uuid from "uuidv4";

import klerData from "../../apis/klerData";

import DropZoneField from "../fileuploader/FileUploader";
const azure = require("azure-storage/browser/azure-storage.blob.export");

const imageIsRequired = value => (!value ? "Required" : undefined);

class RecordEdit extends React.Component {
  state = { imageFile: [], Oid: [] };
  handleFormSubmit = formProps => {
    const fd = new FormData();
    fd.append("imageFile", formProps.imageToUpload.file);
    // append any additional Redux form fields
    // create an AJAX request here with the created formData

    alert(JSON.stringify(formProps, null, 4));
  };

  handleOnDrop = (newImageFile, onChange) => {
    const imageFile = {
      file: newImageFile[0],
      name: newImageFile[0].name,
      preview: URL.createObjectURL(newImageFile[0]),
      size: newImageFile[0].size
    };

    this.setState({ imageFile: [imageFile] }, () => onChange(imageFile));
  };

  resetForm = () => this.setState({ imageFile: [] }, () => this.props.reset());

  render() {
    const updateRecord = formValues => {
      let name = "";
      if (formValues.Oid) {
        name = formValues.Name;
      } else {
        name = uuid();
      }

      if (formValues.Oid) {
        // **************************
        // UPDATE RECORD
        let updatedata = "";
        updatedata = updatedata + "{";
        updatedata = updatedata + 'Name: "' + formValues.Name + '",';
        updatedata =
          updatedata + 'SubscriptionId: "' + formValues.SubscriptionId + '"';
        updatedata = updatedata + "}";
        const RecordEditQuery = `/Media(${parseInt(formValues.Oid)})`;
        axios({
          method: "put",
          url: CONFIG.API_URL + RecordEditQuery,
          data: updatedata,
          headers: {
            "Content-Type": "application/json",
            Auth: CONFIG.API_KEY
          }
        })
          .then(result => {
            this.props.handleCloseReload();
          })
          .catch(error => console.log(error));
      } else {
        // **************************
        // FIRST :: UPLOAD FILE TO AZURE
        const CONNECTION_STRING =
          "DefaultEndpointsProtocol=https;AccountName=klerfiles;AccountKey=am020WmiP81hMONvb9oxuESPf3aYtxuENdZIkLpzqUJOlN3D2nApGmNH5VeBo6bYsXWhrZzRb3FkEkwOZnqAsw==;EndpointSuffix=core.windows.net";
        const BlockBlobContainerName = formValues.SubscriptionId;
        const BlobName = uuid();

        var blobService = azure.createBlobService(CONNECTION_STRING);
        blobService.createContainerIfNotExists(
          BlockBlobContainerName,
          {
            publicAccessLevel: "blob"
          },
          function(error, result, response) {
            if (error) {
              console.log(error);
            } else {
              // Container exists
            }
          }
        );
        // var finishedOrError = false;
        blobService.createBlockBlobFromBrowserFile(
          BlockBlobContainerName,
          BlobName,
          this.state.imageFile[0].file,
          function(error, result, response) {
            // finishedOrError = true;
            if (error) {
              // Upload blob failed
              console.log(error);
            } else {
              // Upload successfully
              createMediaInDatabase();
            }
          }
        );

        const createMediaInDatabase = () => {
          // **************************
          // SECOND :: CREATE MEDIA IN DATABASE
          // https://klerfiles.blob.core.windows.net
          let baseUrl = "/";
          let updatedata = "";
          updatedata = updatedata + "{";
          updatedata = updatedata + 'Name: "' + name + '",';
          updatedata =
            updatedata +
            'Url: "' +
            baseUrl +
            BlockBlobContainerName +
            "/" +
            BlobName +
            '",';
          updatedata =
            updatedata + 'SubscriptionId: "' + formValues.SubscriptionId + '"';
          updatedata = updatedata + "}";

          // CREATE RECORD
          const AddRecordQuery = "/Media";
          axios({
            method: "post",
            url: CONFIG.API_URL + AddRecordQuery,
            data: updatedata,
            headers: {
              "Content-Type": "application/json",
              Auth: CONFIG.API_KEY
            }
          })
            .then(result => {
              // this.props.handleCloseReload();
              selectNewRecord();
            })
            .catch(error => console.log(error));
        };

        // **************************
        // SELECT NEW GROUP
        const selectNewRecord = () => {
          klerData
            .get(
              `/Media?$filter=Name eq '${name}'&$select=Oid,Name&$format=json`
            )
            .then(result => {
              // console.log(result.data.d[0]);
              createMenuItem(result.data.d[0]);
            })
            .catch(error => console.log(error));
        };

        // **************************
        // CREATE MENU ITEM
        const createMenuItem = data => {
          let menudata = "";
          menudata = menudata + "{";
          menudata = menudata + `MediaToShow@odata.bind: "Media(${data.Oid})",`;
          menudata = menudata + `Name: "${formValues.Name}",`;
          menudata = menudata + `Type: "Group",`;
          menudata =
            menudata + `SubscriptionId: "${formValues.SubscriptionId}"`;
          menudata = menudata + "}";
          // console.log(menudata);
          klerData
            .post(`/MenuItems`, menudata)
            .then(result => {
              updateName(data);
            })
            .catch(error => console.log(error));
        };

        // **************************
        // UPDATE GROUP NAME
        const updateName = data => {
          klerData
            .put(`/Media(${data.Oid})`, {
              Name: formValues.Name
            })
            .then(result => {
              this.props.handleCloseReload();
            })
            .catch(error => console.log(error));
        };

        // **************************
        // END CREATE PROCESS
      }
    };
    const onSubmit = formValues => {
      updateRecord(formValues);
    };
    const renderImageField = id => {
      if (id) {
        return null;
      } else {
        return (
          <div>
            <label>Image</label>
            <div>
              <Field
                name="imageToUpload"
                component={DropZoneField}
                type="file"
                imagefile={this.state.imageFile}
                handleOnDrop={this.handleOnDrop}
                validate={[imageIsRequired]}
              />
            </div>
          </div>
        );
      }
    };
    return (
      <div className="txt-center">
        <h4>{this.props.ReferenceTable}</h4>
        <form onSubmit={this.props.handleSubmit(onSubmit)}>
          <div>
            <Field
              name="Oid"
              component="input"
              type="hidden"
              autoComplete="off"
            />
            <Field
              name="SubscriptionId"
              component="input"
              type="hidden"
              autoComplete="off"
            />
          </div>
          <div>
            <label>{this.props.ReferenceTable} Name</label>
            <div>
              <Field
                name="Name"
                component="input"
                type="text"
                placeholder={this.props.ReferenceTable + " Name"}
                autoComplete="off"
              />
            </div>
          </div>
          {renderImageField(this.props.initialValues.Oid)}
          <button className="waves-effect waves-light btn btn-small">
            Submit
          </button>
          &nbsp;
          <button
            type="button"
            className="waves-effect waves-light btn btn-small"
            onClick={this.props.handleClose}
          >
            Cancel
          </button>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    initialValues: {
      Oid: ownProps.data.Oid,
      Name: ownProps.data.Name,
      SubscriptionId: ownProps.SubscriptionId
    },
    Oid: ownProps.data.Oid
  };
};

const validate = formValues => {
  const errors = {};

  if (!formValues.Name) {
    errors.Name = "Please enter a name";
  }

  return errors;
};

export default connect(mapStateToProps)(
  reduxForm({
    form: "RecordEdit",
    validate
  })(RecordEdit)
);
